import React, { Component } from 'react';
import { View } from 'react-native';

import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import { VFButton } from '@vfgroup-oneplatform/foundation/Components';
import {
  withTheme,
  LightThemeColors,
  getThemeImages,
} from '@vfgroup-oneplatform/foundation/Components/Themes';
import Navigation from '@vfgroup-oneplatform/foundation/Utils/Navigation';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import MyPlanCard from '../MyPlanCard';
import MyPlanItem from '../MyPlanItem';

import styles from './MyGroupDataPlan.Styles';

class MyGroupDataPlan extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { theme, images, groupData } = this.props;
    return (
      <MyPlanCard
        status={groupData.status}
        title={groupData.title}
        renewalDate={groupData.renewalDate}
      >
        <View style={styles.usageValuesView}>
          {_map(groupData.usageData, (item, index) => {
            return (
              <MyPlanItem
                key={index}
                {...item}
                containerStyle={styles.usageItemsContainerStyle}
                images={images}
                percentageIndicatorSecondaryColor={theme.colors.activeColor}
                rightTextStyle={styles.rightText(theme)}
              />
            );
          })}
        </View>

        <View style={styles.divider(this.props.theme)} />

        <VFButton
          style={styles.editGroupDataBtn}
          testID={FrameworkTestKeys.GroupDataPlanBtn}
          type="secondary"
          title="my_plan_group_data_edit_button"
          onPress={() => Navigation.instance.navigate('GroupDataPlan')}
        />
      </MyPlanCard>
    );
  }
}

MyGroupDataPlan.defaultProps = {
  theme: LightThemeColors,
  images: getThemeImages(LightThemeColors.name),
};
MyGroupDataPlan.propTypes = {
  theme: PropTypes.object,
  images: PropTypes.object,
  groupData: PropTypes.shape({
    status: PropTypes.string,
    title: PropTypes.string,
    renewalDate: PropTypes.string,
    usageData: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        icon: PropTypes.string,
        leftText: PropTypes.string,
        rightText: PropTypes.string,
        percentageValue: PropTypes.number,
      }),
    ),
  }),
};

export default withTheme(MyGroupDataPlan);
